import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getThreadListMembersMap } from './getThreadListMembersMap';
const getThreadIdFromProps = (state, {
  threadId
}) => threadId;
export const getThreadListMemberByThreadId = createSelector([getThreadIdFromProps, getThreadListMembersMap], (threadId, threadListMembers) => {
  return get(threadId, threadListMembers);
});